export const PAYG = 'PAYG';
const PAYG_30_LABEL_LIMIT = 'PAYG 30 Label Limit';
const PRO_BRONZE = 'Pro Bronze';

export const PRO_PLAN = PRO_BRONZE;
export const STARTER_PLAN = PAYG_30_LABEL_LIMIT;

export const PRO_PLAN_PRICE_DISPLAY = '$19';

export const PRO_PLAN_PITCH_TRANSACTION_THRESHOLD = 5;
